import { useState } from "react";
import Communicator from "../../Helper/Communicator";
import { isPassToAgentItem, startPassToAgent } from "../../Helper/PassToAgent";
import { ConfigMenuItem } from "../../Stores/Config";
import { useRouterStore } from "../../Stores/Router";
import { useTicketStore } from "../../Stores/Ticket";
import { activateOnKey } from "../../Helper/a11y";
import "./WidgetMenuButton.scss";

function WidgetMenuButton({
  menuItem,
  index,
}: {
  menuItem: ConfigMenuItem;
  index: number;
}) {
  const [isLoading, setIsLoading] = useState(false);
  const routerStore = useRouterStore();
  const ticketStore = useTicketStore();

  const handleClick = () => {
    if (isLoading) {
      return;
    }

    // Make component loading
    setIsLoading(true);

    Communicator.trackWidgetEvent("gleap-home-menu-clicked", {
      title: menuItem.title,
      actionType: menuItem.actionType,
    });

    if (menuItem.actionType === "CUSTOM_ACTION") {
      if (menuItem.actionBody) {
        Communicator.runCustomAction(menuItem.actionBody);
        if (menuItem?.closeWidgetAfterAction ?? true) {
          Communicator.closeWidget();
        }
      }
    } else if (menuItem.actionType === "REDIRECT_URL") {
      if (menuItem.actionBody) {
        Communicator.openURL(
          menuItem.actionBody,
          menuItem.actionOpenInNewTab ? true : false
        );
      }
    } else if (isPassToAgentItem(menuItem)) {
      startPassToAgent(menuItem);
    } else if (menuItem.actionType === "BOT") {
      ticketStore.createNewConversation({
        botId: menuItem.botId,
        isManualStart: true,
      });
    } else {
      routerStore.pushPage("flow", {
        flowId: menuItem.actionType,
      });
    }
    setIsLoading(false);
  };

  return (
    <div
      id={`menu-item-${index}`}
      className="widget-menu-button"
      role="button"
      tabIndex={0}
      onClick={handleClick}
      onKeyDown={activateOnKey(handleClick)}
    >
      <div className="widget-menu-button-labels">
        <div className="widget-menu-button-title">{menuItem.title}</div>
        <div className="widget-menu-button-description">
          {menuItem.description}
        </div>
      </div>
      <div className="widget-menu-button-icon">
        <img src={menuItem.icon} alt={menuItem.title} />
      </div>
    </div>
  );
}

export default WidgetMenuButton;
